import { render, staticRenderFns } from "./MemberEditForm.vue?vue&type=template&id=5004e7f4&scoped=true"
import script from "./MemberEditForm.vue?vue&type=script&lang=js"
export * from "./MemberEditForm.vue?vue&type=script&lang=js"
import style0 from "./MemberEditForm.vue?vue&type=style&index=0&id=5004e7f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5004e7f4",
  null
  
)

export default component.exports